import React from 'react';
import { useReactive } from 'ahooks';
import {
  Input,
  Button,
  Dropdown,
  DatePicker,
  Select,
  MessageBox,
  Form,
} from 'kenshin';
import {
  SearchOutlined,
  CloseOutlined,
  DownloadOutlined,
  StarOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import './index.less';

const { RangePicker } = DatePicker;

// 模拟资产数据
const mockAssets = [
  {
    id: '1',
    type: 'image',
    url: 'https://picsum.photos/seed/asset1/200/200',
    name: '端午海报1',
    time: '2026-06-29',
  },
  {
    id: '2',
    type: 'image',
    url: 'https://picsum.photos/seed/asset2/200/200',
    name: '端午海报2',
    time: '2026-06-28',
  },
  {
    id: '3',
    type: 'image',
    url: 'https://picsum.photos/seed/asset3/200/200',
    name: '端午海报3',
    time: '2026-06-27',
  },
  {
    id: '4',
    type: 'video',
    url: 'https://picsum.photos/seed/asset4/200/200',
    name: '端午视频',
    time: '2026-06-26',
  },
  {
    id: '5',
    type: 'image',
    url: 'https://picsum.photos/seed/asset5/200/200',
    name: '产品海报',
    time: '2026-06-25',
  },
  {
    id: '6',
    type: 'image',
    url: 'https://picsum.photos/seed/asset6/200/200',
    name: '节日祝福',
    time: '2026-06-24',
  },
];

const AssetLibrary = ({ onClose }) => {
  const state = useReactive({
    assets: [...mockAssets],
    searchValue: '',
    assetType: 'all', // all, image, video
    timeRange: null,
    collectModalVisible: false,
    collectAsset: null,
  });

  const [formRef] = Form.useForm();

  // 过滤资产
  const filteredAssets = state.assets.filter((asset) => {
    if (state.assetType !== 'all' && asset.type !== state.assetType)
      return false;
    if (state.searchValue && !asset.name.includes(state.searchValue))
      return false;
    return true;
  });

  // 右键菜单
  const assetMenu = (asset) => (
    <Dropdown.Menu>
      <Dropdown.Item>
        <div
          onClick={() => {
            // 下载逻辑
          }}
        >
          下载
        </div>
      </Dropdown.Item>
      <Dropdown.Item>
        <div
          onClick={() => {
            state.collectAsset = asset;
            state.collectModalVisible = true;
          }}
        >
          收藏
        </div>
      </Dropdown.Item>
    </Dropdown.Menu>
  );

  // 提交收藏
  const handleCollectSubmit = () => {
    formRef.validateFields().then((values) => {
      console.log('收藏参数：', values);
      state.collectModalVisible = false;
      state.collectAsset = null;
    });
  };

  return (
    <div className="assetLibrary">
      {/* 头部 */}
      <div className="assetHeader">
        <span className="assetTitle">资产库</span>
        <CloseOutlined className="closeIcon" onClick={onClose} />
      </div>

      {/* 搜索栏 */}
      <div className="assetSearch">
        <Input
          placeholder="搜索你的资产"
          value={state.searchValue}
          onChange={(e) => (state.searchValue = e.target.value)}
          prefix={<SearchOutlined />}
          size="small"
          className="searchInput"
        />
        <RangePicker size="small" className="datePicker" />
      </div>

      {/* 分类标签 */}
      <div className="assetTabs">
        <div
          className={`assetTab${
            state.assetType === 'all' ? ' assetTabActive' : ''
          }`}
          onClick={() => (state.assetType = 'all')}
        >
          全部资产
        </div>
        <div
          className={`assetTab${
            state.assetType === 'image' ? ' assetTabActive' : ''
          }`}
          onClick={() => (state.assetType = 'image')}
        >
          图片
        </div>
        <div
          className={`assetTab${
            state.assetType === 'video' ? ' assetTabActive' : ''
          }`}
          onClick={() => (state.assetType = 'video')}
        >
          视频
        </div>
      </div>

      {/* 资产列表 */}
      <div className="assetList">
        {filteredAssets.map((asset) => (
          <Dropdown overlay={assetMenu(asset)} trigger={['contextMenu']}>
            <div key={asset.id} className="assetItem">
              <img src={asset.url} alt={asset.name} />
              {asset.type === 'video' && <div className="videoBadge">视频</div>}
            </div>
          </Dropdown>
        ))}
      </div>

      {/* 收藏弹窗 */}
      <MessageBox
        title="收藏到资产库"
        visible={state.collectModalVisible}
        onOk={handleCollectSubmit}
        onCancel={() => {
          state.collectModalVisible = false;
          state.collectAsset = null;
        }}
        okText="确认收藏"
        cancelText="取消"
      >
        <Form form={formRef} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <Form.Item label="资产类型" name="assetType" initialValue="public">
            <Select
              options={[
                { label: '公共资产库', value: 'public' },
                { label: '个人资产库', value: 'personal' },
              ]}
            />
          </Form.Item>
          <Form.Item label="标签" name="tags">
            <Input placeholder="输入标签，用空格分隔" />
          </Form.Item>
        </Form>
      </MessageBox>
    </div>
  );
};

export default AssetLibrary;
